











import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { ISentEmail } from "@/models/emails";
import { SentEmailStatus } from "@/data/enums/emails";
import { DataModules } from "@/store/modules/data/index";

@Component
export default class EmailHistoryStatus extends Vue {
  // Props

  @Prop({ required: true })
  public email!: ISentEmail;

  @Prop({ default: "is-right" })
  public position!: string;

  public get dateUpdatedFormatted() {
    return this.$store.getters["utils/time/formatCalendar"](
      this.email.updated_at,
      {
        sameElse: () => {
          return this.$t("_datetime.date.long") as string;
        }
      }
    );
  }

  public get i18n() {
    return {
      bounced:
        this.email.bounced_at && this.email.sent_at
          ? this.$t("_.email_bounced_after", { time: this.bouncedTimeFrom })
          : this.email.bounced_at
          ? this.$t("_.email_bounced", { time: this.bouncedTimeAt })
          : "",
      sent: this.$t("_.email_sent"),
      error: this.$t("_.send_failed_date", {
        date: this.dateUpdatedFormatted
      }),
      sending: this.$t("_sentence.email_is_being_processed")
    };
  }

  public get status() {
    const status = this.$store.getters[`data/${DataModules.EMAILS}/status`](
      this.email
    ) as SentEmailStatus;

    if (status === SentEmailStatus.ERROR) {
      return {
        icon: "exclamation-circle",
        type: "is-danger",
        desc: this.i18n.error
      };
    } else if (status === SentEmailStatus.BOUNCED) {
      return {
        icon: "exclamation-circle",
        type: "is-warning",
        desc: this.i18n.bounced
      };
    } else if (status === SentEmailStatus.SENT) {
      return {
        icon: "check-circle",
        type: "is-success",
        desc: this.i18n.sent
      };
    } else if (status === SentEmailStatus.SENDING) {
      return {
        icon: "info-circle",
        type: "is-info",
        desc: this.i18n.sending
      };
    } else return null;
  }

  public get bouncedTimeFrom() {
    return this.$moment(this.email.sent_at).from(
      this.$moment(this.email.bounced_at),
      true
    );
  }

  public get bouncedTimeAt() {
    return this.$moment
      .utc(this.email.bounced_at)
      .local()
      .fromNow();
  }
}
